<template>
  <v-container fluid class="vendor-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Vendor</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                    <v-row justify="center">
                      <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">New Vendor</p>
                        <v-text-field
                          class="mb-4"
                          v-model="vendor.vendorname"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Vendor Name"
                          persistent-hint
                          single-line hint="Enter the vendorname">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="vendor.vendorcontact"
                          outlined
                          dense
                          placeholder="Contact Person"
                          persistent-hint
                          single-line hint="Enter the contact person">
                        </v-text-field>
                        <v-select
                          :items="vendortypes"
                          class="mb-4"
                          v-model="vendor.vendortype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the vendor type">
                        </v-select>
                        <v-select
                          v-if="type=='service'"
                          class="mb-4"
                          :items="countries.map(x => {return {text: x.countryname, value: x._id};})"
                          v-model="vendor.countryid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Country"
                          persistent-hint
                          single-line hint="Please choose the country">
                        </v-select>
                        <v-select
                          v-if="type=='rental'"
                          class="mb-4"
                          :items="regions.map(x => {return {text: x.regionname, value: x._id};})"
                          v-model="vendor.regionid"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>
                        <v-row no-gutters>
                          <v-col cols="12" md="6">
                            <v-switch
                              v-model="vendor.vendorstatus"
                              color="primary"
                              v-bind:label="vendor.vendorstatus=='Active' ? vendor.vendorstatus : 'Inactive'"
                              value="Active"
                              false-value="Inactive"
                              hint="Status"
                              persistent-hint
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-switch
                              color="primary"
                              v-model="vendor.isPaymentNotify"
                              hint="Notify Payment"
                              :false-value="false"
                              persistent-hint
                            ></v-switch>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-textarea
                          v-model="vendor.vendoraddress"
                          outlined
                          rows=3
                          label="Address"
                          hint="please enter the vendor address"
                        ></v-textarea>
                        <v-text-field
                          class="mb-4"
                          v-model="vendor.vendorphone"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the vendor phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="vendor.vendormobile"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the vendor mobile">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="vendor.vendoremail"
                          outlined
                          dense
                          placeholder="Email"
                          persistent-hint
                          single-line hint="Enter the vendor email">
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6" sm="5">
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/vendor/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertVendor()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3"></v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      vendor: {},
      vendortypes: ['Vendor', 'Supplier', 'Other Vendor'],
      step: 1,
      type: null,
      imageurl: undefined,
      isRental: false,
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Country', ['countries']),
    ...mapState('Region', ['regions']),
    ...mapState('Vendor', ['isReceiving']),
  },
  methods: {
    ...mapActions('Country', ['getCountriesRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('SystemSetting', ["getSetting"]),
    ...mapActions('Vendor', ['insertVendorRequest','insertVendorWithImageRequest','getVendorsRequest']),
    checkError(){
      if(!this.vendor.vendorname){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.vendor.vendortype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(this.type=='service' && !this.vendor.countryid){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertVendor() {
      this.vendor.vendorstatus = this.vendor.vendorstatus=='Active' ? this.vendor.vendorstatus : 'Inactive';
      if(this.vendor.vendorimage!=null) await this.insertVendorWithImageRequest(this.vendor);
      else await this.insertVendorRequest(this.vendor);
      router.push('/vendor/list');
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.vendor.vendorimage = file;
      this.vendor.imagename = file.name;
      this.createImage(file);
    }
  },
  async created(){
    if(this.countries.length==0) await this.getCountriesRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    this.isRental = await this.getSetting({code: 'CompanySettings', name: 'isRental'}, );
    this.isRental==true ? this.type='rental' : this.type='service';
  }
}
</script>
<style src="./Add.scss" lang="scss"></style>
